import {
  BarController,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Tooltip,
} from 'chart.js';
import { memo } from 'react';
import { Bar } from 'react-chartjs-2';

import { WorkOrderData } from '../../../../api/workOrders/types';
import { CHART_TITLES } from '../../constants';
import { volumeByMonth } from '../../utils/aggregations';
import { ChartCard } from '../ChartCard';

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  Tooltip,
  Legend,
  BarController
);

interface VolumeChartProps {
  data: WorkOrderData[];
}

function VolumeChartImpl({ data }: VolumeChartProps): JSX.Element {
  const buckets = volumeByMonth(data);
  const chartData = {
    labels: buckets.map((b) => b.monthLabel),
    datasets: [
      {
        label: 'OS criadas',
        data: buckets.map((b) => b.created),
        backgroundColor: '#7B3FF2',
        borderRadius: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'bottom' as const },
    },
    scales: {
      y: { beginAtZero: true, ticks: { precision: 0 } },
    },
  };

  return (
    <ChartCard
      title={CHART_TITLES.volume}
      fullWidth
      ariaLabel={`Histograma de OS criadas nos últimos 12 meses, total ${buckets.reduce(
        (acc, b) => acc + b.created,
        0
      )} OS`}
    >
      <Bar data={chartData} options={options} />
    </ChartCard>
  );
}

export const VolumeChart = memo(VolumeChartImpl);
